import { Outlet } from 'react-router';
import { useMeta } from 'common/hooks';
import { metaConfig } from '@tiangong/layout/meta.config';

import Slogan from 'common/assets/bg/slogan@1x.webp';
import SloganTG from 'common/assets/bg/slogan-tg.png';
import cx from './index.module.css';

const LoginLayout = ({ seo }: { seo?: boolean }) => {
  // 动态往 HTML Head 中注入 meta 标签
  useMeta(seo ? metaConfig : []);

  return (
    <div className={cx('login-layout')}>
      <div className={cx('login-layout-introduce')}>
        <video
          src={'https://static.fuxi.netease.com/xuniren/index_module/index/lzkoe536_121857.mp4'}
          poster="https://static.fuxi.netease.com/xuniren/index_module/index/lzksdwmx_829368.png"
          autoPlay
          loop
          muted
          playsInline
          className={cx('bg-video')}
        />

        <div className={cx('main')}>
          <div className={cx('introduce-title')}>
            <img src={window.EEVEE_FOR_INTERNAL === 'true' ? SloganTG : Slogan} alt="绘梦天工" />
          </div>
        </div>
      </div>

      <Outlet />

      <div className={cx('bg-mask')}></div>
    </div>
  );
};

export default LoginLayout;
